import { gql } from "@apollo/client";


export const WORK_SESSION_LOG_SCAN = gql`
    mutation WorkSessionLogScan($input: WorkSessionLogScanInput!) {
        workSessionLogScan(input: $input) {
            label
            message
            workSessionLog {
                id
                work_session_id
                action
                status
                reason
                detail
                created_at
            }
        }
    }
`;
